import colorTokensThemed from '@orus.eu/design-tokens/tokens/color-tokens.json'

export const colorTokens = Object.keys(colorTokensThemed.colorTokens['light']).reduce(
  (styles, key) => ({
    ...styles,
    [key]: `var(--${key})`,
  }),
  {} as Record<keyof (typeof colorTokensThemed.colorTokens)['light'], string>,
)

export type ColorToken = keyof (typeof colorTokensThemed.colorTokens)['light']
